import { useState } from "react";
import tickImage from "../assets/images/double-tick.png";
import noteImage from "../assets/images/notes.png";
import plusImage from "../assets/images/plus.png";
import { useSelector } from "react-redux";
import {
	useAddTodoMutation,
	useEditTodoStatusMutation,
	useGetTodosQuery,
	useDeleteTodoMutation,
} from "../features/api/apiSlice";

export default function Header() {
	const [input, setInput] = useState("");
	const [addTodo] = useAddTodoMutation();
	const { status, colors } = useSelector((state) => state.filters);
	const [editTodoStatus] = useEditTodoStatusMutation();
	const [deleteTodo] = useDeleteTodoMutation();
	const { data: todos } = useGetTodosQuery({ status, colors });

	const submitHandler = (e) => {
		e.preventDefault();

		addTodo({
			text: input,
			completed: false,
		});
		setInput("");
	};

	const completeHadler = () => {
		todos.forEach((todo) => {
			if (todo.completed === false) {
				editTodoStatus({
					id: todo.id,
					data: {
						completed: true,
					},
				});
			}
		});
	};

	const clearHeandler = () => {
		todos.forEach((todo) => {
			if (todo.completed === true) {
				deleteTodo({
					id: todo.id,
				});
			}
		});
	};

	return (
		<div>
			<form
				className="flex items-center bg-gray-100 px-4 py-4 rounded-md"
				onSubmit={submitHandler}
			>
				<img src={noteImage} className="w-6 h-6" alt="Add todo" />
				<input
					type="text"
					placeholder="Type your todo"
					className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
					value={input}
					onChange={(e) => setInput(e.target.value)}
				/>
				<button
					type="submit"
					className={`appearance-none w-8 h-8 bg-no-repeat bg-contain`}
				>
					<img src={plusImage} alt="" className="" />
				</button>
			</form>

			<ul className="flex justify-between my-4 text-xs text-gray-500">
				<li className="flex space-x-1 cursor-pointer" onClick={completeHadler}>
					<img className="w-4 h-4" src={tickImage} alt="Complete" />
					<span>Complete All Tasks</span>
				</li>
				<li className="cursor-pointer" onClick={clearHeandler}>
					Clear completed
				</li>
			</ul>
		</div>
	);
}
